import type { ReactNode } from "react";

/**
 * A closeable window in the right-column stack. The right side can hold several
 * of these vertically (e.g. the synapse preview + a pipeline), each with its own
 * header and × close. The body scrolls independently.
 */
export function PanelWindow({
  title, onClose, children,
}: {
  title: string;
  onClose: () => void;
  children: ReactNode;
}) {
  return (
    <section className="panel-window">
      <header className="panel-window-head">
        <span className="panel-window-title">{title}</span>
        <button className="panel-window-close" onClick={onClose} title="Close" aria-label={`Close ${title}`}>
          ×
        </button>
      </header>
      <div className="panel-window-body">{children}</div>
    </section>
  );
}
